import {FetchPolicy} from '@apollo/client';
import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import ProcedureDropdown from './ProcedureDropdown';

interface LabeledProcedureDropdownProps {
  procedureId: string | null;
  setProcedureId: (procedureId: string) => void;
  onRequestCloseModal: () => void;
  procedureType: ProcedureType;
  requiredField: boolean;
  dropdownDisabled: boolean;
  procedureFetchPolicy: FetchPolicy;
}

/*
 * A procedure selection dropdown grouped with an appropriate label based on the given procedure type.
 */
export function LabeledProcedureDropdown(props: LabeledProcedureDropdownProps): JSX.Element {
  return (
    <FormGroup>
      <FieldLabel
        label={getProcedureUIString(ProceduresStringKeys.PROCEDURE, props.procedureType, {
          stringCase: StringCase.SENTENCE,
        })}
        isRequired={props.requiredField}
      />
      <ProcedureDropdown
        isDisabled={props.dropdownDisabled}
        procedureType={props.procedureType}
        selectedProcedureId={props.procedureId}
        onChangeSelectedProcedure={props.setProcedureId}
        onRequestCloseModal={props.onRequestCloseModal}
        procedureFetchPolicy={props.procedureFetchPolicy}
      />
    </FormGroup>
  );
}
